import React, {Fragment} from 'react'
import {Field} from 'formik'
import {Grid, Grow, Typography} from '@material-ui/core'
import DropInput from '../../../../components/DropInput'
import SelectField from '../../../../components/SelectField'

import {COMPANY_DOCUMENT_TYPES} from '../../../../constants'

import {StepHeader} from '../../styles'

const Step12 = () => {
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Passo 3 de 3
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Vamos precisar do seu contrato social ou carta MEI.
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              label="Tipo de documento"
              native
              name="documentType"
              component={SelectField}
            >
              <option aria-label="None" value="" />
              {COMPANY_DOCUMENT_TYPES.map(({label, value}) => (
                <option aria-label={label} value={value}>{label}</option>
              ))}
            </Field>
          </Grid>
          <Grid item xs={12}>
            <Field
              accept=".pdf, application/pdf"
              name="image"
              label="Contrato social"
              defaultMessage="Arraste ou clique para selecionar o arquivo."
              component={DropInput}
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  );
};

export default Step12;
